import { render } from "./NetworkIssue.vue?vue&type=template&id=edf43efc"
import script from "./NetworkIssue.vue?vue&type=script&lang=js"
export * from "./NetworkIssue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__